import { keyframes } from 'glamor'
import { UiTheme } from '../../theme'

const rotateAnimationName = keyframes({
  from: {
    transform: 'rotate(0)',
  },
  to: {
    transform: 'rotate(360deg)',
  },
})

const dashAnimationName = keyframes({
  '0%': {
    strokeDasharray: '1, 150',
    strokeDashoffset: '0',
  },
  '50%': {
    strokeDasharray: '90, 150',
    strokeDashoffset: '-35',
  },
  '100%': {
    strokeDasharray: '90, 150',
    strokeDashoffset: '-124',
  },
})

export default (_theme: UiTheme) => ({
  loader: {
    base: {
      display: 'inline-block',
      position: 'relative',
      verticalAlign: 'middle',
    },
  },

  spinner: {
    base: {
      animation: 'rotate 2s linear infinite',
      zIndex: 2,
      width: '100%',
      height: '100%',
      animationName: rotateAnimationName,
      display: 'block',
    },
  },

  circle: {
    base: {
      strokeLinecap: 'round',
      animation: 'dash 1.5s ease-in-out infinite',
      animationName: dashAnimationName,
    },
  },
})
